import { escapeCsvField } from '@/marketing/lib/csvExport';
import type { ContentTrackingExportPurpose, ContentTrackingExportRow } from '@/marketing/models/contentTracking';

function metric(value: number | null): string {
  return value === null ? '' : String(value);
}

// Report rows carry the widest video set so every creator's N-th video lands in the same column.
export function generateContentTrackingCsv(
  rows: ContentTrackingExportRow[],
  purpose: ContentTrackingExportPurpose,
): string {
  if (purpose === 'reminders') {
    const header = 'Handle,Platform,Stage,Email,Tracking No.,Tracking Link,Package Status';
    const lines = rows.map((row) =>
      [
        row.handle ?? '',
        row.platform ?? '',
        row.stage,
        row.email ?? '',
        row.shippingTracking ?? '',
        row.trackingUrl ?? '',
        row.packageStatus ?? '',
      ]
        .map(escapeCsvField)
        .join(','),
    );
    return [header, ...lines].join('\n');
  }
  const slots = rows.reduce((max, row) => (row.videos ?? []).reduce((slotMax, video) => Math.max(slotMax, video.slot), max), 1);
  const videoHeaders = Array.from({ length: slots }, (_, index) => {
    const n = index + 1;
    return [
      `Video ${n} Link`,
      `Video ${n} Mandatory`,
      `Video ${n} Views`,
      `Video ${n} Likes`,
      `Video ${n} Comments`,
      `Video ${n} Saves`,
      `Video ${n} ER %`,
      `Video ${n} Posted`,
      `Video ${n} Top`,
    ];
  }).flat();
  const header = ['Handle', 'Platform', 'Stage', ...videoHeaders].join(',');
  const lines = rows.map((row) => {
    const cells = [row.handle ?? '', row.platform ?? '', row.stage];
    for (let index = 0; index < slots; index += 1) {
      const video = row.videos?.find((item) => item.slot === index + 1);
      cells.push(
        video?.url ?? '',
        video ? (video.mandatory ? 'yes' : 'no') : '',
        metric(video?.views ?? null),
        metric(video?.likes ?? null),
        metric(video?.comments ?? null),
        metric(video?.saves ?? null),
        video?.engagementRate == null ? '' : video.engagementRate.toFixed(2),
        video?.postedAt ?? '',
        video?.topVideo ? 'yes' : '',
      );
    }
    return cells.map(escapeCsvField).join(',');
  });
  return [header, ...lines].join('\n');
}
